import { Injectable, signal } from '@angular/core';
import { PefApiData } from '@sportello-balneari/pef-editor';
import type {
  PefReportParameters,
  TenderFormAnswerEconomicOfferCriteria,
} from '../../../api/interfaces';

/** State of the Offerta Economica tab: the PEF workbook and the economic offer. */
@Injectable()
export class PefStateService {
  /** Live user inputs to persist on save; updated on every cell edit. */
  readonly pefInput = signal<PefApiData | null>(null);
  /**
   * Inputs that drive the PEF recalculation. Only updated when the user
   * explicitly recalculates (Calcola), on reload, or on year-range change —
   * never on a plain cell edit, so editing does not trigger a server recalc.
   */
  readonly pefCalcInput = signal<PefApiData | null>(null);
  readonly pefSavedVersion = signal<number>(0);
  readonly pefStartYear = signal<number | null>(null);
  readonly pefEndYear = signal<number | null>(null);
  /**
   * PEF generation of the loaded answer — not to be confused with
   * {@link pefSavedVersion}, which is a save counter. Decides how the year
   * range is counted; `null` means the pre-v3 inclusive counting. See
   * `pef-year-span.ts`.
   */
  readonly pefVersion = signal<number | null>(null);
  readonly pefReportParameters = signal<PefReportParameters | null>(null);

  readonly economicOfferAnswer = signal<{ [key: string]: unknown } | null>(
    null,
  );
  readonly economicOfferCriteria =
    signal<TenderFormAnswerEconomicOfferCriteria | null>(null);
}
